import { useUser, useClerk } from "@clerk/react";
import { useLocation } from "wouter";
import { useGetMe } from "@workspace/api-client-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { LogOut, User as UserIcon, Bell } from "lucide-react";

export function UserMenu() {
  const { user } = useUser();
  const { signOut } = useClerk();
  const { data: me } = useGetMe();
  const [, setLocation] = useLocation();

  if (!user) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="outline-none">
        <div className="h-7 w-7 rounded-md bg-secondary border border-border flex items-center justify-center text-xs font-medium text-foreground hover:bg-muted transition-colors">
          {user.firstName?.charAt(0) || user.emailAddresses[0]?.emailAddress.charAt(0) || <UserIcon className="w-4 h-4" />}
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="font-normal">
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none text-foreground">{user.fullName || "User"}</p>
            <p className="text-xs leading-none text-muted-foreground">
              {user.emailAddresses[0]?.emailAddress}
            </p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {me && (
          <div className="px-2 py-1.5 text-xs">
            <div className="flex justify-between items-center mb-1">
              <span className="text-muted-foreground">Role</span>
              <span className="font-mono text-[10px] uppercase bg-secondary px-1.5 py-0.5 rounded border border-border">{me.role}</span>
            </div>
            {me.pullerName && (
              <div className="flex justify-between items-center">
                <span className="text-muted-foreground">Puller</span>
                <span className="text-foreground">{me.pullerName}</span>
              </div>
            )}
          </div>
        )}
        <DropdownMenuSeparator />
        {me?.pullerId != null && (
          <DropdownMenuItem onClick={() => setLocation("/notifications")} className="cursor-pointer">
            <Bell className="mr-2 h-4 w-4" />
            <span>Notifications</span>
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={() => signOut()} className="text-destructive focus:bg-destructive/10 focus:text-destructive cursor-pointer">
          <LogOut className="mr-2 h-4 w-4" />
          <span>Log out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
